export default "__VITE_ASSET__DcLw29c5__"